import { useEffect, useRef } from "react";
import { Modal, ModalProp } from "../../../components/modal/Modal";
import { Dialog } from "@headlessui/react";
import { FormBox, ModalFoterBox } from "../../../components/box/Box";
import Button from "../../../components/button/Button";
import { useForm } from "react-hook-form";
import { nowDate, OptionContract, optionContractSchema } from "../../../model/OptionContract";
import { RadioButton } from "../../../components/radiobutton/RadioButton";
import FormController from "../../../components/fields/FormController";
import { useInput } from "../../../hooks/useInput";
import { yupResolver } from "@hookform/resolvers/yup";

export type OptionContractProp = {
  selectOption: OptionContract;
  onClickConfirm: (data: OptionContract) => Promise<void>;
}

export const OptionContractModal = ({
  open,
  toggle,
  closeOnClickOutside,
  updateFlg,
  selectOption,
  onClickConfirm,
}: ModalProp & OptionContractProp) => {

  const { control, handleSubmit, getValues, setValue } =
    useForm<OptionContract>({resolver: yupResolver(optionContractSchema),});

  const defaultApplicableStartDate = useRef(selectOption.applicableStartDate);
  const defaultApplicableFinishDate = useRef(selectOption.applicableFinishDate);
  const selectStatus = useInput(getDefaultStatus());

  useEffect(() => {
    setValue('id', selectOption.id ?? '');
    setValue('optionId', selectOption.optionId);
    setValue('optionName', selectOption.optionName);
    setValue('status', selectStatus.value === "0" ? false : true );
    setValue('applicableStartDate', selectOption.applicableStartDate);
    setValue('applicableFinishDate', selectOption.applicableFinishDate);
  },[selectOption, setValue, updateFlg, open]);

  function getDefaultStatus () {
    const status = selectOption.status ? "1" : "0";
    const startDate = defaultApplicableStartDate.current;
    const finishDate = defaultApplicableFinishDate.current;
    if(status === "1" && (
      (startDate !== null && finishDate !== null && startDate <= nowDate && finishDate >= nowDate && startDate <= finishDate) || 
      (startDate === null && finishDate === null) || 
      (finishDate === null && startDate !== null && startDate <= nowDate) || 
      (startDate === null && finishDate !== null && finishDate >= nowDate) ||
      (startDate !== null && startDate > nowDate)))
    {
      return "1";
    }
    return "0";
  }

  // 契約状況ラジオボタンの表示更新
  useEffect(() => {
    setValue('status', selectStatus.value === "1" ? true : false);
  },[selectStatus, setValue]);

  // 契約状況ラジオボタン
  const selectStatusItem = [
    {id: "1", title: "有効"},
    {id: "0", title: "無効"},
  ];

  // 契約状況で「無効」を選択した時に初期値を設定する
  useEffect(() => {
    if (selectStatus.value === "0") {
      setValue('applicableStartDate', defaultApplicableStartDate.current ?? "");
      setValue('applicableFinishDate', defaultApplicableFinishDate.current ?? "");
    }
  }, [selectStatus])

  return(
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          <form
            className=""
            onSubmit={handleSubmit(onClickConfirm)}
          >
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <h3 className="text-left text-lg font-medium leading-6 text-gray-900">
                オプション契約編集：{selectOption.optionName}
              </h3>
              <h4 className="text-left text-sm font-medium leading-6 text-gray-500 mt-2">　オプションを設定して下さい</h4>

              <div className="overflow-y-auto">
                <div className="px-2 text-left pb-8 ml-10">
                  <FormBox className="mb-5" gridcol={""}>
                    <div className="flex sm:items-center">
                      <h3 className="text-sm text-gray-900">契約状況</h3>
                      <RadioButton
                        children={undefined}
                        name={"status"}
                        label={""}
                        value={selectStatus}
                        radioButtonItem={selectStatusItem}
                        vertical 
                        labelClassName={"mr-0"}
                      />
                    </div>
                  </FormBox>
                  <div className="flex sm:items-center">
                    <FormBox className={""} gridcol={""}>
                      <div className="flex items-center">
                        <h3 className="text-sm text-gray-900 ml-7 mr-8">開始日</h3>
                        <FormController
                          control={control}
                          name={"applicableStartDate"}
                          label={""}
                          type={"date"}
                          className={`items-center w-36${selectStatus.value === "0" ? " opacity-60" : ""}`}
                          disabled={selectStatus.value === "0"}
                        />
                        <h3 className="text-sm text-gray-900 ml-20 mr-8">終了日</h3>
                        <FormController
                          control={control}
                          name={"applicableFinishDate"}
                          label={""}
                          type={"date"}
                          className={`items-center w-36${selectStatus.value === "0" ? " opacity-60" : ""}`}
                          disabled={selectStatus.value === "0"}
                        />
                      </div>
                    </FormBox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              className="mt-1 mr-2 w-[132px]"
              submit
              children={"確認"}
            />
          </ModalFoterBox>
          </form>
        </Dialog.Panel>
      </Modal>
    </>
  );
}

